import { State } from '../State';

export type PlatformStorageEntry = {
  count: number;
  first: number; // Timestamp in MS
  last: number; // Timestamp in MS
  lastAdEntry: number;
};

// Same typing as in GCInstant
// https://github.com/play-co/gcinstant/blob/master/src/analytics/demographics.ts#L9
type AgeRange = { min: number; max?: number };
export type Gender = 'male' | 'female';
export type PlatformStorageDemographics = {
  /** Confidence in 0-99% on age range estimation. */
  ageConfidence?: number;

  /** User's estimated inclusive age range. */
  ageRange?: AgeRange;

  gender?: Gender;
};

// Same parsing as in GCInstant
// https://github.com/play-co/gcinstant/blob/master/src/analytics/demographics.ts#L29
export function ageRangeFromString(input: string): AgeRange | undefined {
  if (/^\d{1,3}$/.test(input)) {
    return { min: 0, max: Number(input) };
  } else if (/^\d{1,3}\+$/.test(input)) {
    return { min: Number(input.replace('+', '')) };
  } else if (/^\d{1,3}-\d{1,3}$/.test(input)) {
    const [min, max] = input.split('-').map((intStr) => Number(intStr));

    return { min, max };
  }

  return undefined;
}

/**
 * Get platform storage entry data
 **/
export function getPlatformStorageEntry(
  state: State,
): PlatformStorageEntry | undefined {
  return state.platformStorage?.entry as PlatformStorageEntry;
}

/**
 * Check if first session
 **/
export function isFirstSession(state: State): boolean {
  const data = getPlatformStorageEntry(state);

  if (!data) {
    return true;
  }

  if (data.count && data.count <= 1) {
    return true;
  }

  return false;
}
